export var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus[InvoiceStatus["Concept"] = 1] = "Concept";
    InvoiceStatus[InvoiceStatus["Definitief"] = 2] = "Definitief";
})(InvoiceStatus || (InvoiceStatus = {}));
